import { UnsubscribeFunction } from "callback-registry";
import { Glue42 } from "../../glue";

export class PanelAPI implements Glue42.Notifications.NotificationPanelAPI {

    constructor(private interop: Glue42.Interop.API, private onStreamEvent: <T>(key: string, callback: T) => UnsubscribeFunction) {
    }

    public onVisibilityChanged(callback: (isVisible: boolean) => void): UnsubscribeFunction {
        return this.onStreamEvent("on-panel-visibility-changed", callback);
    }

    public toggle(): Promise<any> {
        return this.interop.invoke("T42.Notifications.Show");
    }

    public show(): Promise<any> {
        return this.interop.invoke("T42.Notifications.Show", { show: true });
    }

    public hide(): Promise<any> {
        return this.interop.invoke("T42.Notifications.Hide");
    }

    public async isVisible(): Promise<boolean> {
        const interopResult = await this.interop.invoke<{ panelVisible: boolean }>("T42.Notifications.Execute", { command: "isPanelVisible" });
        return interopResult.returned.panelVisible;
    }

    public toAPI(): Glue42.Notifications.NotificationPanelAPI {
        return {
            onVisibilityChanged: this.onVisibilityChanged.bind(this),
            toggle: this.toggle.bind(this),
            show: this.show.bind(this),
            hide: this.hide.bind(this),
            isVisible: this.isVisible.bind(this)
        };
    }
}
